// extracted by mini-css-extract-plugin
export default {"root":"b06fDRCumKnD0vJk8gtm","wrap":"OQ_2Xt7nFi5uGstFUMPB","icon":"jtrS2WWLucs3ALT2eBJK","copy":"HQl6fgmhRVrDBlYAsnaj","back":"kjKCPWhq9vxmPvyRXmLA"};